import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListTokenUidCell } from './emsp-bo-charging-session-list-token-uid.cell';
import { EmspBoChargingSessionListTokenUidHeader } from './emsp-bo-charging-session-list-token-uid.header';

export const EmspBoChargingSessionListTokenUidColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['tokenUid']
> = {
  enableSorting: false,
  header: EmspBoChargingSessionListTokenUidHeader,
  cell: EmspBoChargingSessionListTokenUidCell,
  meta: { maxWidth: '130px', width: '120px', minWidth: '80px' },
};
